export default __webpack_public_path__ + "static/media/phone icon 1.63a1ddb1.svg";